import { AwsConfig as AwsConstants } from './Constants';

import BaseService, { RequestInterface } from './Base';
import IPagination from '../interfaces/IPagination';
import Ticket from '../interfaces/qafs/ticket';
import TicketPaginationQuery from '../interfaces/ticket-pagination-query';
import TaskflowValue from '../interfaces/taskflow-value';

export default class TicketService extends BaseService {
    constructor () {
        super(AwsConstants.API_QAFS, 'ticket');
    }

    async paging (unitId: string, query: TicketPaginationQuery, fields?: string[]): Promise<IPagination<Ticket>> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unitId;
        if (query.limit) {
            params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
            params.queryStringParameters['offset'] = query.offset;
        }
        if (query.from != null) {
            params.queryStringParameters['from'] = query.from;
        }
        if (query.to != null) {
            params.queryStringParameters['to'] = query.to;
        }
        if (query.status != null) {
            params.queryStringParameters['status'] = query.status;
        }
        if (query.search) {
            params.queryStringParameters['search'] = query.search;
        }

        const res = await super.get<IPagination<Ticket>>('', params);
        return res;
    }

    async me (unitId: string, query: TicketPaginationQuery, fields?: string[]): Promise<IPagination<Ticket>> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unitId;
        if (query.limit) {
            params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
            params.queryStringParameters['offset'] = query.offset;
        }
        const res = await super.get<IPagination<Ticket>>('me', params);
        return res;
    }

    async my (unitId: string, query: TicketPaginationQuery, fields?: string[]): Promise<IPagination<Ticket>> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        params.queryStringParameters['unit'] = unitId;
        if (query.limit) {
            params.queryStringParameters['limit'] = query.limit;
        }
        if (query.offset) {
            params.queryStringParameters['offset'] = query.offset;
        }

        const res = await super.get<IPagination<Ticket>>('my', params);
        return res;
    }

    async getById (id: string, fields?: string[]): Promise<Ticket> {
        const params: RequestInterface = {
            queryStringParameters: super.setFields(fields)
        };
        const res = await super.get<Ticket>(id, params);
        return res;
    }
    async notificationExec (id: string, eventId: string): Promise<void> {
        await super.patch<void>(`${id}/notification/${eventId}`);
    }
    async processExec (id: string, eventId: string, data: TaskflowValue): Promise<void> {
        const params: RequestInterface = {
            body: data
        };
        await super.patch<void>(`${id}/process/${eventId}`, params);
    }
    async start (workflowId: string, distributorId: string, unitId: string, data: TaskflowValue): Promise<Ticket> {
        const params: RequestInterface = {
            queryStringParameters: { distributor: distributorId, unit: unitId },
            body: data
        };
        const res = await super.patch<Ticket>(`workflow/${workflowId}`, params);
        return res;
    }
}